import type {
  AddCorrelations,
  CorrelationErrors,
  Correlations,
  CorrelationsAddCorrelation,
  CorrelationsUpdateCorrelation
} from '@library/types/correlations';
import {
  AddCorrelationsRow,
  UpdateCorrelationsRow,
  ViewCorrelationsRow
} from '@bo-components/correlations';
import type { ComboboxOption } from '@library/components/selects';

export interface CorrelationsDetailsProps {
  allStatTypes: Array<ComboboxOption>;
  errors: CorrelationErrors;
  hasEditCorrelations?: boolean;
  isNewRowsOnly?: boolean;
  newCorrelations?: AddCorrelations;
  onAddCorrelationsChange?: (correlation: CorrelationsAddCorrelation) => void;
  onDeleteCorrelation?: ({ correlationId }: { correlationId: string }) => void;
  onUpdateCorrelationsChange?: (
    correlation: CorrelationsUpdateCorrelation
  ) => void;
  updatedCorrelations?: Correlations;
}

export const CorrelationsDetails = ({
  allStatTypes,
  errors,
  hasEditCorrelations = false,
  isNewRowsOnly = false,
  newCorrelations = [],
  onAddCorrelationsChange = () => {},
  onDeleteCorrelation = () => {},
  onUpdateCorrelationsChange = () => {},
  updatedCorrelations = []
}: CorrelationsDetailsProps) => {
  const viewCorrelations = hasEditCorrelations
    ? updatedCorrelations.map((correlation) => (
        <UpdateCorrelationsRow
          key={correlation.id}
          allStatTypes={allStatTypes}
          correlation={correlation}
          onCorrelationsChange={onUpdateCorrelationsChange}
        />
      ))
    : updatedCorrelations.map((correlation) => (
        <ViewCorrelationsRow key={correlation.id} correlation={correlation} />
      ));

  return (
    <tbody>
      {isNewRowsOnly
        ? newCorrelations.map((correlation) => {
            const correlationPublishError = errors.find(
              (error) => error.correlationId === correlation.correlationId
            );

            return (
              <AddCorrelationsRow
                key={correlation.id}
                allStatTypes={allStatTypes}
                correlation={correlation}
                correlationPublishError={correlationPublishError}
                onDeleteCorrelation={onDeleteCorrelation}
                onCorrelationsChange={onAddCorrelationsChange}
              />
            );
          })
        : viewCorrelations}
    </tbody>
  );
};
